export default {
    PtImagePanel: {
        page: 'View full page',
        image: 'View image only',
    },
};
